import React from 'react';
import { withStyles } from '../../mui-styles-bridge.js';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { TipTapEditor } from './TipTap';

const styles = () => ({
  root: {
    marginTop: '1rem',
    '& .MuiAlert-standardError .MuiAlert-icon': {
      color: '#B00020',
    },
    '& .MuiAlert-standardError': {
      backgroundColor: 'rgba(176, 0, 32, 0.15)',
      marginTop: '16px',
      width: 'fit-content',
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: '400',
      border: '1px solid rgba(176, 0, 32, 1)',
    },
  },
});

const characterLimit = 1073741823;

class RichTextEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
      showWarning: false,
    };
  }

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];
    if (answer_data && answer_data.answer) {
      this.setState({
        answer: this.props.form.answer_data[this.props.data.key].answer[0],
        showWarning:
          this.props.form.answer_data[this.props.data.key].answer[0].length >
          characterLimit,
      });
    } else {
      if (
        this.props.data.data !== undefined &&
        this.props.data.data.toString() &&
        this.state.answer === ''
      ) {
        this.setState({
          answer: this.props.data.data,
          showWarning: this.props.data.data.length > characterLimit,
        });
        this.props.getDataFromComponent(
          { text_answer: this.props.data.data },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.data !== prevProps.data.data) {
      this.props.getDataFromComponent(
        { text_answer: this.props.data.data },
        this.props.data.key,
        this.props.data.question_text,
        this.props.data.data
      );
      this.setState({
        answer: this.props.data.data,
        showWarning: this.props.data.data.length > characterLimit,
      });
    }
  }

  handleChange = (value) => {
    this.setState({ answer: value });
  };

  handleBlur = (value, event) => {
    // Check if the blur is due to clicking a toolbar button
    if (
      event &&
      event.relatedTarget &&
      event.relatedTarget.className &&
      (event.relatedTarget.className.includes('toolbar') ||
       event.relatedTarget.className.includes('tiptap'))
    ) {
      return;
    }

    // Check character limit
    if (value.length > characterLimit) {
      this.setState({ showWarning: true });
    } else {
      this.setState({ showWarning: false });
    }

    this.setState({ answer: value });
    this.props.getDataFromComponent(
      { text_answer: value },
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  handleRecurseTree = (ele, key) => {
    let i = 0;
    const toBeTraversedArray = [ele];
    toBeTraversedArray.push(ele);

    while (toBeTraversedArray.length > 0) {
      let currentNode = toBeTraversedArray.shift();
      currentNode.id = `${key}-${i}`;
      if (i === 1) currentNode.className = 'annotation-content-block';
      i++;

      if (currentNode.childNodes.length > 0) {
        toBeTraversedArray.push(...currentNode.childNodes);
      }
    }

    return ele;
  };

  addIdsToContentBlock = (html, key) => {
    let parser = new DOMParser();
    let htmlDoc = parser.parseFromString(html, 'text/html');
    const newEle = this.handleRecurseTree(htmlDoc.body, key);
    return newEle.outerHTML;
  };

  render() {
    const { data, classes } = this.props;
    const { answer, showWarning } = this.state;

    return (
      <div className={classes.root}>
        <TipTapEditor
          value={answer}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          readOnly={data.read_only}
          showToolbar={!data.read_only}
          minHeight="500px"
          characterLimit={characterLimit}
        />
        <Alert
          severity="error"
          icon={<ErrorIcon />}
          style={{
            display: showWarning ? null : 'none',
          }}
        >
          You have reached the character limit for this editor
        </Alert>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {};

RichTextEditor.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RichTextEditor));
